<template>
    <div id="preorder">
        <div class="preorder-body">
            <van-cell
                    to="/addresslist/1"
                    class="address-item"
                    v-show="sendList.length <= 0"
            >
                <span slot="icon" class="address-icon ji-icon"></span>
                <div class="item-info">
                    请点击输入寄件人相关信息
                </div>
                <span class="address-book" slot="right-icon"></span>
            </van-cell>
            <address-item
                    :type="'1'"
                    v-for="(item, index) in sendList"
                    :key="index"
                    :address-info="item"
                    :index="index"
            />
            <van-cell class="address-item" style="margin-top: .1rem" v-if="mark != 'dgdlyyb'">
                <span slot="icon"> 服务网点</span>
                <div class="item-info">
                    <span class="organ_name" :class="params.organId==item.organId?'organ_name_checked':' '"
                          @click="params.organId=item.organId"
                          v-for="item in serviceList" :key="item.id">{{item.organName}}</span>
                </div>
            </van-cell>

            <van-cell
                    to="/acceptAddressList"
                    class="address-item"
                    v-show="acceptList.length <= 0"
            >
                <span class="address-icon shou-icon" slot="icon"></span>
                <div class="item-info">
                    请点击输入收货人相关信息
                </div>
                <span class="address-book" slot="right-icon"></span>
            </van-cell>

            <accept-address
                    v-for="(item, index) in acceptList"
                    :key="item.id"
                    :address-info="item"
                    :showDel="acceptList.length !== 1"
                    @on-pay-means-click="handlePayMeansClick(index)"
                    @on-delivery-click="handleDeliveryClick(index)"
                    @on-pack-click="handlePackClick(index)"
                    @on-product-click="handleProductClick(index)"
            ></accept-address>

            <!-- 付款方式选择框 -->
            <van-actionsheet
                    @select="selPayMent"
                    @cancel="cancelPayMent"
                    v-model="show.pay"
                    :actions="$store.state.dict.pay"
                    cancel-text="重置"
            ></van-actionsheet>
            <!-- 配送方式选择框 -->
            <van-actionsheet
                    @select="selDelivery"
                    @cancel="cancelDelivery"
                    v-model="show.delivery"
                    :actions="$store.state.dict.delivery"
                    cancel-text="重置"
            ></van-actionsheet>
            <!-- 品名 -->
            <van-actionsheet
                    style="max-height: 60%"
                    @select="selProduct"
                    @cancel="cancelProduct"
                    v-model="show.product "
                    :actions="$store.state.dict.product"
                    cancel-text="重置"
            ></van-actionsheet>
            <!-- 包装 -->
            <van-actionsheet
                    @select="selPack"
                    @cancel="cancelPack"
                    v-model="show.pack"
                    :actions="$store.state.dict.pack"
                    cancel-text="重置"
            ></van-actionsheet>

        </div>

        <div class="btn">
            <van-button to="/acceptAddressListMulti" size="large" type="danger">批量添加收件人</van-button>
            <van-button @click="submit" size="large" type="danger">提交</van-button>
        </div>
    </div>
</template>

<script>
    import {Dialog, Toast} from "vant";
    import AddressItem from "../components/SelAddressItem.vue";
    import Coupon from "../components/Coupon.vue";

    export default {
        name: "PreOrder",
        components: {
            AcceptAddress: () => import('./address/components/CheckedAcceptAddress'),
            AddressItem,
            Coupon
        },
        data() {
            return {
                mark: this.$route.query.mark,
                show: {
                    timePicker: false,
                    company: false,
                    worker: false,
                    transport: false,
                    pack: false,
                    pay: false,
                    delivery: false,
                    message: false,
                    coupon: false,
                    product: false,
                },
                columns: {},
                timeColumns: [],
                workerRadio: "",
                companyList: [],
                concatWorkerList: [],
                workerList: [],
                transportwayList: [],
                packList: [],
                payList: [],
                deliveryList: [],
                couponList: [],
                serviceList: [//服务网点
                    {
                        address: "广东省广州市白云区白云湖街道南约大街6号",
                        distance: 1210,
                        locationCoordinates: "113.258399,23.222481",
                        organId: "034cf81975fb4e4ba730ce4c3dfd1da9",
                        organName: "夏茅总部",
                        phone: "18576951333",
                    },
                    {
                        address: "广东省广州市番禺区大石街道广州市尚境建筑模型有限公司深蓝工业园",
                        distance: 1210,
                        locationCoordinates: "113.287383,23.010381",
                        // organId: "c2e46c8dfa804133a77205d27e6d72e3",
                        organId: "fdbc92c551654223bc4482ba93068191",
                        organName: "番禺地区",
                        phone: "18576951333",
                    },
                    {
                      address: "广东省广州市白云区石井街道凤鸣路2号锦东国际服装城",
                      distance: 1210,
                      locationCoordinates: "113.220595,23.205097",
                      organId: "be34b517e6c44879b85101a20b5d20ba",
                      organName: "东莞大朗",
                      phone: "18666118508",
                    }
                ],
                workerSearchKey: "",
                coupon: 0,
                index: null,
                logisticsCompanyId: '',
                logisticsCompanyName: '',
                params: {
                    // goodsNumber: null,
                    // consigneeAddress: null,
                    // consigneeProvinceId: null,
                    // consigneeCityId: null,
                    // consigneeDistrictId: null,
                    // consigneeProvinceName: null,
                    // consigneeCityName: null,
                    // consigneeDistrictName: null,
                    // consigneeStreetId: null,
                    // consigneeStreetName: null,
                    // consigneePhone: null,
                    // consigneeName: null,
                    deliveryId: "3",
                    deliveryName: "市场配送",
                    lat: "",
                    lng: "",
                    orderType: 5,
                    organId: "",
                    packId: "1",
                    packName: "纤袋",
                    // payMeansId: "2",
                    // payMeansName: "到付",
                    // planPickupTime: "",
                    // pullPackWorker: "",
                    // pullPackWorkerName: "",
                    // speedParts: "1",
                    speedPartsName: "特快件",
                    sourceType: "WeChat",
                    staOrderDetail: [],
                    consigneeList: [],
                    weight: 0,
                    // couponId: "",
                    // isNeedFiberBag: "1",
                    // pickUpName: "",
                    // remark: ""
                }
            };
        },
        mounted() {
            this.getDefault(1);
            this.getDefault(2);
        },
        computed: {
            sendList() {
                return this.$store.getters.getCheck("1");
            },
            acceptList() {
                return this.$store.getters.getCheck("2");
            }
        },
        activated() {
            if (this.$route.query.mark) {
                localStorage.setItem('mark', this.$route.query.mark)
            }
            if (localStorage.getItem('mark') === 'yqhb') {
              this.params.logisticsCompanyId = this.$logisticsCompanyId_hb
              this.params.logisticsCompanyName = this.$logisticsCompanyName_hb
            } else if(localStorage.getItem('mark') === 'dgdlyyb') {
              this.params.logisticsCompanyId = 'be34b517e6c44879b85101a20b5d20ba'
              this.params.logisticsCompanyName = '云企东莞大朗'
            } else {
              this.params.logisticsCompanyId = this.$logisticsCompanyId
              this.params.logisticsCompanyName = this.$logisticsCompanyName
            }
        },
        watch: {
            workerSearchKey(newVal) {
                this.workerList.forEach(val => {
                    if (
                        val.name.indexOf(newVal) !== -1 ||
                        val.phone.indexOf(newVal) !== -1
                    ) {
                        val.show = true;
                    } else {
                        val.show = false;
                    }
                });
                this.concatWorkerList.forEach(val => {
                    if (
                        val.name.indexOf(newVal) !== -1 ||
                        val.phone.indexOf(newVal) !== -1
                    ) {
                        val.show = true;
                    } else {
                        val.show = false;
                    }
                });
            },
        },
        methods: {
            getDefault(type) {
                let params = {
                    params: {
                        addressType: type,
                        defaultAddress: "1"
                    }
                };
                this.$axios.post("merchant/getAddressByType", params).then(res => {
                    if (res.data.code === 200) {
                        let data = res.data.data;
                        if (Array.isArray(data)) {
                            data.forEach(val => {
                                val.check = true;
                                val.goodsNumber = null
                                val.payMeansName = '到付'
                                val.payMeansId = '2'
                                val.deliveryName = '市场配送'
                                val.deliveryId = '3'
                                val.packId = '1'
                                val.packName = '纤袋'
                                val.productName = '服装'
                                val.productId = '1'
                            });
                        }
                        if (type === 1 && Array.isArray(data)) {
                            this.$store.commit({
                                type: "confirmSelect",
                                t: "1",
                                list: data
                            });
                        } else if (type === 2 && Array.isArray(data)) {
                            this.$store.commit({
                                type: "confirmSelect",
                                t: "2",
                                list: data
                            });
                        }
                    }
                });
            },
            handlePayMeansClick(i) {
                this.index = i
                this.show.pay = true
            },
            handleDeliveryClick(i) {
                this.index = i
                this.show.delivery = true
            },
            handlePackClick(i) {
                this.index = i
                this.show.pack = true
            },
            handleProductClick(i) {
                this.index = i
                this.show.product = true
            },
            // 快慢件弹出框
            transportwayToggle() {
                this.show.transport = !this.show.transport;
            },
            // 打包弹出框
            packToggle() {
                this.show.pack = !this.show.pack;
            },
            // 付款方式弹出
            payToggle() {
                this.show.pay = !this.show.pay;
            },
            productToggle() {
                this.show.product = !this.show.product;
            },
            // 运输方式弹出框
            deliveryToggle() {
                this.show.delivery = !this.show.delivery;
            },
            // 关闭
            closeCompany() {
                this.show.company = false;
            },
            closeWorker() {
                this.show.worker = false;
            },
            // 删除地址
            delSend(id) {
                this.$store.commit({
                    type: "selAddress",
                    t: "1",
                    id
                });
            },
            // 快慢件选择
            selTransport(item) {
                this.params.speedParts = item.dictValue;
                this.params.speedPartsName = item.dictName;
                this.transportwayToggle();
            },
            // 包装选择
            selPack(item) {
                let list = JSON.parse(JSON.stringify(this.acceptList))
                list[this.index].packId = item.dictValue;
                list[this.index].packName = item.dictName;
                this.$store.commit({
                    type: "confirmSelect",
                    t: 2,
                    list: list
                })
                this.packToggle();
            },
            // 付款选择
            selPayMent(item) {
                let list = JSON.parse(JSON.stringify(this.acceptList))
                list[this.index].payMeansId = item.dictValue
                list[this.index].payMeansName = item.dictName
                this.$store.commit({
                    type: "confirmSelect",
                    t: 2,
                    list: list
                })
                this.payToggle();
            },
            // 配送选择
            selDelivery(item) {
                let list = JSON.parse(JSON.stringify(this.acceptList))
                list[this.index].deliveryId = item.dictValue
                list[this.index].deliveryName = item.dictName
                this.$store.commit({
                    type: "confirmSelect",
                    t: 2,
                    list: list
                })
                this.deliveryToggle();
            },

            // 重置
            cancelTransport() {
                this.params.speedPartsName = "特快件";
                this.params.speedParts = "1";
            },
            //品名
            selProduct(item) {
                let list = JSON.parse(JSON.stringify(this.acceptList))
                list[this.index].productId = item.dictValue
                list[this.index].productName = item.dictName
                this.$store.commit({
                    type: "confirmSelect",
                    t: 2,
                    list: list
                })
                this.productToggle()
            },
            cancelProduct() {
                let list = JSON.parse(JSON.stringify(this.acceptList))
                list[this.index].ProductId = "1"
                list[this.index].ProductName = "服装"
                this.$store.commit({
                    type: "confirmSelect",
                    t: 2,
                    list: list
                })
            },
            cancelPack() {
                let list = JSON.parse(JSON.stringify(this.acceptList))
                list[this.index].packId = "1";
                list[this.index].packName = "纤袋";
                this.$store.commit({
                    type: "confirmSelect",
                    t: 2,
                    list: list
                })
            },
            cancelPayMent() {
                let list = JSON.parse(JSON.stringify(this.acceptList))
                list[this.index].payMeansName = "到付";
                list[this.index].payMeansId = "2";
                this.$store.commit({
                    type: "confirmSelect",
                    t: 2,
                    list: list
                })
            },
            cancelDelivery() {
                let list = JSON.parse(JSON.stringify(this.acceptList))
                list[this.index].deliveryId = 3
                list[this.index].deliveryName = "市场配送"
                this.$store.commit({
                    type: "confirmSelect",
                    t: 2,
                    list: list
                })
            },
            cancelTime() {
                this.params.planPickupTime = "";
                this.timeToggle();
            },
            cancelWorker() {
                this.workerRadio = "";
                this.params.pullPackWorker = "";
                this.params.pullPackWorkerName = "";
                this.workerToggle();
            },
            // 提交
            submit() {
                if (this.sendList.length <= 0) {
                    Dialog.alert({
                        title: "温馨提醒",
                        message: "请选择发货人地址！"
                    }).then(() => {
                        return false;
                    });
                    return false;
                }
                if (this.acceptList.length <= 0) {
                    Dialog.alert({
                        title: "温馨提醒",
                        message: "请选择收货人！"
                    }).then(() => {
                        return false;
                    });
                    return false;
                }
                if (!this.acceptList.every(val => val.goodsNumber)) {
                    Dialog.alert({
                        title: "温馨提醒",
                        message: "请输入货物件数！"
                    }).then(() => {
                        return false;
                    });
                    return false;
                }
                if (!this.params.organId && this.mark != 'dgdlyyb') {
                    Dialog.alert({
                        title: "温馨提醒",
                        message: "请选择网点！"
                    }).then(() => {
                        return false;
                    });
                    return false;
                }
                this.params.wechatMark = this.$wechatMark;
                //this.params.logisticsCompanyId = this.logisticsCompanyId
                //this.params.logisticsCompanyName = this.logisticsCompanyName
                this.params.lat = this.sendList[0].lat || 0;
                this.params.lng = this.sendList[0].lng || 0;
                this.acceptList.forEach(val => {
                    let obj = {
                        productName: val.productName,
                        productId: val.productId,
                        packName: val.packName,
                        packId: val.packId,
                        consigneeProvinceName: val.provinceName,
                        consigneeProvinceId: val.provinceId,
                        consigneeCityName: val.cityName,
                        consigneeCityId: val.cityId,
                        consigneeDistrictName: val.districtName,
                        consigneeDistrictId: val.districtId,
                        consigneeStreetName: val.streetName,
                        consigneeStreetId: val.streetId,
                        consigneeAddress: val.address,
                        consigneePhone: val.concatPhone,
                        consigneeName: val.name,
                        payMeansId: val.payMeansId,
                        payMeansName: val.payMeansName,
                        deliveryId: val.deliveryId,
                        deliveryName: val.deliveryName,
                        goodsNumber: val.goodsNumber || 1,
                        weight: val.weight || 1,
                        lng: val.lng,
                        lat: val.lat,

                    }
                    this.params.consigneeList.push(obj)
                })
                this.sendList.forEach(val => {
                    let obj = {
                        clothingCityId: val.clothingCityId,
                        consignorName: val.name,
                        consignorPhone: val.concatPhone,
                        consignorProvinceName: val.provinceName,
                        consignorProvinceId: val.provinceId,
                        consignorCityName: val.cityName,
                        consignorCityId: val.cityId,
                        consignorDistrictName: val.districtName,
                        consignorDistrictId: val.districtId,
                        consignorStreetName: val.streetName,
                        consignorStreetId: val.streetId,
                        consignorAddress: val.address,
                        // deliveryWeight: val.deliveryWeight,
                        // goodsNumber: val.goodsNumber || 1,
                        lat: val.lat || 0,
                        lng: val.lng || 0,
                        needWheelbarrow: 0,
                        planDeliveryDate: val.planDeliveryDate || "",
                        // packId: val.packId || "",
                        // packName: val.packName || "",
                        consignorId: val.id
                    };
                    if (val.stc) {
                        obj.needWheelbarrow = 1;
                    }
                    this.params.staOrderDetail.push(obj);
                });
                let params = {
                    params: this.params
                };

                this.$axios.post("merchant/addOrder/batch", params).then(res => {
                    if (res.data.code === 200) {
                        Dialog.alert({
                            title: "温馨提示",
                            message: "下单成功！"
                        }).then(() => {
                            this.params = {
                                deliveryId: "3",
                                deliveryName: "市场配送",
                                lat: "",
                                lng: "",
                                //logisticsCompanyId: this.logisticsCompanyId,
                                //logisticsCompanyName: this.logisticsCompanyName,
                                orderType: 5,
                                organId: "",
                                packId: "1",
                                packName: "纤袋",
                                speedPartsName: "特快件",
                                sourceType: "WeChat",
                                staOrderDetail: [],
                                consigneeList: [],
                                weight: 0,
                            }
                            this.coupon = 0;
                            this.workerRadio = "";
                            this.getDefault(1);
                            this.getDefault(2);
                            window.location.href = location.href + '?time=' + ((new Date()).getTime());
                        });
                    } else {
                        window.location.href = location.href + '?time=' + ((new Date()).getTime());
                    }
                })
            }
        }
    };
</script>

<style lang="scss" scoped>
    #preorder {
        .preorder-body {
            flex: 1;
            overflow: scroll;
            padding-bottom: 1.83rem;
        }


        .address-item {
            display: -webkit-box;
            -webkit-box-align: center;
            color: #999;

            .item-info {
                font-weight: bold;
            }

            .address-icon {
                margin-right: 0.25rem;
                width: 0.64rem;
                height: 0.9rem;
                display: block;
                box-sizing: border-box;
                padding: 4px 8px 12px;
                background-repeat: no-repeat;
                background-position: center;
                background-size: 100%;

                &.ji-icon {
                    background-image: url(../assets/order2.png);
                }

                &.shou-icon {
                    background-image: url(../assets/order1.png);
                }
            }

            .address-book {
                display: block;
                width: 0.5rem;
                height: 0.5rem;
                background-image: url(../assets/contact.png);
                background-size: 100%;
                background-repeat: no-repeat;
                background-origin: content-box;
                border-left: 1px solid #ddd;
                padding-left: 0.25rem;
            }

            .address-book-btn {
                font-size: 0.3rem;
                line-height: 0.6rem;
                display: block;
                padding: 0 0.15rem;
                border: 1px solid #0b92e6;
                color: #0b92e6;
                margin-left: 0.25rem;
            }

            .address-del {
                display: block;
                height: 0.6rem;
                line-height: 0.6rem;
                padding: 0 0.25rem;
                border: 1px solid #0b92e6;
                color: #0b92e6;
            }

            .info-name,
            .info-address {
                color: #000;
            }
        }

        .icon {
            display: block;
            width: 0.4rem;
            height: 0.4rem;
            margin-right: 0.25rem;
            background-size: 100%;
            background-repeat: no-repeat;

            &.info-shou {
                background-image: url(../assets/icon_destination.png);
            }

            &.info-time {
                background-image: url(../assets/icon_tihuo.png);
            }

            &.icon-company {
                background-image: url(../assets/icon_company.png);
            }

            &.icon-worker {
                background-image: url(../assets/icon_linkman.png);
            }

            &.icon-coupon {
                background-image: url(../assets/icon_coupon.png);
                height: 0.5rem;
            }

            &.add-worker {
                background-image: url(../assets/icon_addlinkman.png);
            }

            &.icon-transportway {
                background-image: url(../assets/icon_type.png);
            }

            &.icon-pack {
                background-image: url(../assets/icon_pack.png);
            }

            &.goods-weight {
                background-image: url(../assets/icon_weight.png);
            }

            &.icon-payment {
                background-image: url(../assets/icon_paymengt.png);
            }

            &.icon-delivery {
                background-image: url(../assets/icon_delivery.png);
            }

            &.icon-microphone {
                background-image: url(../assets/icon-microphone.png);
                width: 0.3rem;
                height: 0.45rem;
            }
        }

        .li-col {
            float: left;
            box-sizing: border-box;
            padding: 0.25rem 0.4rem;
            margin: 0.2rem 0;
            font-size: 0.35rem;
            position: relative;
            width: 100%;

            &.li-col-2 {
                width: 50%;
            }
        }

        .flex-layout {
            display: flex;
            align-items: center;
        }

        .order-info {
            width: 100%;
            background-color: #fff;
            border-bottom: 1px solid #eee;

            &::after {
                content: "";
                display: block;
                clear: both;
            }

            > .li-col-2 {
                &:nth-of-type(2n) {
                    border-left: 1px solid #eee;
                }

                > .info-name {
                    flex: 1;
                }

                > .coupon-price {
                    color: red;
                    margin-right: 0.25rem;
                }
            }
        }

        .goods-info {
            width: 100%;
            background-color: #fff;

            &::after {
                content: "";
                display: block;
                clear: both;
            }

            > .li-col-2 {
                border: 0;

                > .info-value {
                    flex: 1;
                }
            }
        }

        .btn {
            /*padding: 0.25rem;*/
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            padding: 0.25rem 0;
            background-color: #f5f5f5;

            .van-button {
                width: 45%;
                margin: 0;
                height: 1.33rem;
                line-height: 1.33rem;
            }
        }

        .popup-title {
            position: relative;
            display: flex;
            align-items: center;
            padding: 0.25rem;
            font-size: 0.4rem;

            .van-button {
                margin-left: 0.25rem;
            }

            .van-icon {
                position: absolute;
                right: 0.25rem;
            }
        }

        .company-popup {
            .company-list {
                max-height: 6rem;
                overflow-y: scroll;

                .company-item {
                    .company-icon {
                        width: 1.25rem;
                        height: 1.25rem;
                        display: block;
                        background-image: url(../assets/wuliu1.png);
                        background-size: 100%;
                        background-repeat: no-repeat;
                        border: 1px solid #ddd;
                        margin-right: 0.25rem;
                    }

                    .company-time {
                        float: right;
                    }
                }
            }
        }

        .worker-popup {
            .worker-list {
                .worker-item {
                    display: flex;
                    align-items: center;

                    .add2book {
                        display: block;
                        width: 45px;
                        font-size: 12px;
                        color: #b3b3b3;
                        line-height: 14px;
                    }

                    .worker-info {
                        width: 7rem;
                        display: flex;
                        align-items: center;

                        .worker-header {
                            width: 1.25rem;
                            height: 1.25rem;
                            display: block;
                            background-image: url(../assets/wuliu1.png);
                            background-size: 100%;
                            background-repeat: no-repeat;
                            border: 1px solid #ddd;
                            margin-right: 0.25rem;
                        }
                    }
                }
            }
        }

        .coupon-popup {
            height: 10rem;
            overflow: hidden;

            .close-btn {
                display: inline-block;
                height: 0.5rem;
                width: 0.5rem;
                position: relative;
                transform: rotate(-45deg);
                margin-top: 0.25rem;
                margin-right: 0.25rem;

                &::before {
                    content: "";
                    display: block;
                    width: 100%;
                    height: 100%;
                    border: 1px solid transparent;
                    border-bottom: 1px solid #999;
                    position: absolute;
                    top: -50%;
                }

                &::after {
                    content: "";
                    display: block;
                    width: 100%;
                    height: 100%;
                    border: 1px solid transparent;
                    border-right: 1px solid #999;
                    position: absolute;
                    left: -50%;
                }
            }
        }

        .organ_name {
            float: right;
            padding: .1rem .3rem;
            font-weight: 300;
            border: 1px solid #ccc;
            border-radius: .5rem;
            margin-right: .3rem;
        }

        .organ_name_checked {
            color: red;
            border: 1px solid red;
            overflow: hidden;
        }
    }
</style>
